import { DateUtils } from "utilities/date-utils";
import { FileRecord } from "models/view-models/files/file-record";
import { InstructorApplicationFile } from "models/interfaces/aen-applications/instructor-application-file";
import {
    InstructorApplicationFileType,
    InstructorApplicationFileTypeDisplayNames,
} from "models/enumerations/aen-applications/instructor-application-file-type";
import { Record } from "immutable";
import { RecordUtils } from "andculturecode-javascript-core";
import { UserRecord } from "models/view-models/users/user-record";
import { t } from "utilities/localization/t";

// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: InstructorApplicationFile = {
    createdBy: undefined,
    createdById: undefined,
    createdOn: undefined,
    deletedById: undefined,
    deletedOn: undefined,
    description: undefined,
    file: undefined,
    fileId: 0,
    id: undefined,
    instructorApplicationId: 0,
    type: undefined,
    updatedById: undefined,
    updatedOn: undefined,
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class InstructorApplicationFileRecord
    extends Record(defaultValues)
    implements InstructorApplicationFile
{
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<InstructorApplicationFile>) {
        params = params ?? Object.assign({}, defaultValues);

        if (params.createdBy != null) {
            params.createdBy = RecordUtils.ensureRecord(params.createdBy, UserRecord);
        }

        if (params.file != null) {
            RecordUtils.ensureRecord(params.file, FileRecord);
        }

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------
    /**
     * Convenience method to the return type Enum string with spaces between each word.
     * Ex: EducationNetwork -> Training Space
     */
    public getFileTypeDisplayName(): string {
        if (this == null || this.type == null) {
            return "";
        }
        const fileType = this.type as InstructorApplicationFileType;
        return t(InstructorApplicationFileTypeDisplayNames[fileType]);
    }

    /**
     * Convenience method to get the upload user's first and last name
     * @returns {string} Randy Jenkins
     */
    public getFirstAndLastName(): string {
        return this.createdBy?.getFirstAndLastName() ?? "";
    }

    /**
     * Convenience method to get the upload date
     * @returns {string} MM/DD/YYYY formatted date string
     */
    public getUploadDate(): string {
        return DateUtils.formatDate(true, this.createdOn);
    }

    public with(values: Partial<InstructorApplicationFile>): InstructorApplicationFileRecord {
        return new InstructorApplicationFileRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

// #endregion Record

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { InstructorApplicationFileRecord };

// #endregion Exports
